import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import injectSheet from 'react-jss'
import {UnstyledLink} from '../Widgets/Link'
import AddToBag from './AddToBag'
import AddToWishlist from './AddToWishlist'
import {truncateString} from '../../utils/truncateString'

const Price = ({classes, item}) => {
    if (!item.price) return item.loaded ? '' : '...';

    if (!item.special_price || item.special_price === 0)
        return `$${item.price}`;

    return [
        <span key='price' className={classes.strikeout}>${item.price}</span>,
        <span key='special' className={classes.sale} style={{ color: item.ribbon.color }}>${item.special_price}</span>
    ]
} 

class ShopTheLookItem extends PureComponent {

    render() {
        const {classes, classNames={}, className, item, universalMenu, showAddToBag, size='medium'} = this.props;
        if(!item) return null;

        return <div className={cn(classes.item, className, size)}>
            {item.sizes &&
            <UnstyledLink link={{url: item.url, target: '_blank', ga_tracking: item.ga_tracking, rel: item.rel}}
                          className={cn(classes.itemImageFrame, classNames.imageFrame)}>
                <img src={item.sizes[size] || item.sizes.medium} alt={item.title} className={cn(classes.itemImage, classNames.itemImage)}/>
            </UnstyledLink>
            }
            <div className={cn(classNames.contentContainer, classes.meta)}>
                <div>
                    {item.sku && <div className={cn(classes.brand, classNames.brand)}>{item.brand ? item.brand : item.loaded ? '' : '...'}</div>}
                    <div className={cn(classes.product, classNames.product)}>{truncateString(item.title,16)}</div>
                    {item.sku && <div className={cn(classes.price, classNames.price)}><Price classes={classes} item={item} /></div>}
                    {item.ribbon && item.ribbon.type && <div className={cn(classes.ribbon, classNames.ribbon)} style={{ color: item.ribbon.color }}>{item.ribbon.short}</div>}
                    {universalMenu && showAddToBag && <AddToBag product={item} />}
                </div>
                {universalMenu && <AddToWishlist product={item} classNames={classNames.wishListClassNames} />}
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

export default injectSheet( (theme) => (
{
    meta: {
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'left'
    },
    item: {
        position: 'relative',
        fontSize: 12,
        lineHeight: '16px',
        textAlign: 'left',
        width: 150,
        margin: '0 10px 0 0',
        '&:last-child': {
            margin: '0 0 0 0'
        },
        '&.medium': {
            width: 120,
            '& > a': {
                height: 'auto'
            }
        },
        [theme.breakpoint('tablet')]: {
            width: 200,
            '&.medium': {
                width: 160
            }
        }
    },
    product: {
        lineHeight: '24px',
        letterSpacing: '0.3px',
        fontSize: 14,
        color: '#B0B0B0',
        [theme.breakpoint('tablet')]: {
            fontSize: 15
        }
    },
    brand: {
        fontWeight: 'bold',
        letterSpacing: '0.3px',
        fontSize: 14,
        lineHeight: '24px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'initial',
        [theme.breakpoint('tablet')]: {
            fontSize: 14
        }
    },
    price: {
        fontSize: 14,
        color: theme.colors.black,
        lineHeight: '24px',
        letterSpacing: '0.3px',
        [theme.breakpoint('tablet')]: {
            fontSize: 14
        }
    },
    itemImageFrame: {
        display: 'block',
        background: '#F3F3F7',
        height: 193,
        width: '100%',
        marginBottom: 15,
        [theme.breakpoint('tablet')]: {
            height: 269
        }
    },
    itemImage: {
        backgroundColor: theme.colors.assent,
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        display: 'block',
        '&:hover': {
            filter: 'brightness(100%)'
        }
    },
    ribbon: {
        letterSpacing: '0.84px',
        fontWeight: 600,
        textTransform: 'uppercase'
    },
    strikeout: {
        textDecoration: 'line-through'
    },
    sale: {
        fontWeight: 400,
        marginLeft: theme.spacing.tiny
    }

}))(connect(mapStateToProps)(ShopTheLookItem))



// WEBPACK FOOTER //
// ./src/components/ShopThLook/ShopTheLookItem.js